<template>
<div>
<div class="page">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="left">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/dataReport' }" style="color:red">报表查询</el-breadcrumb-item>
            <el-breadcrumb-item>{{this.$route.name}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="right">
            <input type="text"  class="search" placeholder="请输入关键字"  v-model="input" @input="inputlist()">
            <img src="../../assets/img/search.png" class="searchImg" alt="搜索" >
            <div class="searchlist" v-if="searchliststatus">
                <ul>
                  <li style="color:rgba(0, 103, 255, 1)">指标：</li>
                  <li  v-for="(item,index) in searchlistzb"
                        :key="index"
                        @click="searchcheck(item,index)"
                    >
                      {{item.resName}}
                    </li>
                    <li style="color:rgba(0, 103, 255, 1)">文章：</li>
                  <li  v-for="(item,index) in searchlistwz"
                        :key="index"
                        @click="wzlistcheck(item)"
                    >
                      {{item.resName}}
                    </li>
                </ul>
             </div>
        </div>
      </div>
      <div class="article-title">{{report_name}}</div>
      <div class="article-content" style="width:100%">
          
          <design :report_id="report_id" :report_name="report_name" ref="design"></design>
      </div>
      
  </div> 
  <div class="article-foot">
    <span>郴州市统计局</span>
    <span>技术支持：浙江鸿程计算机系统有限公司</span>
  </div>
</div> 
</template>

<script>
import {getarticle} from '@/api/info.js'
import {searchdata} from '@/api/index.js'
import design from "@/components/handsontable/design.vue";
import { getReportlist,getpdlist,getReport  } from '@/api/dataReport.js'
export default {
  components: {
      design
    },
  data(){
      return{
        report_id: '',
        report_name: '',
        content:'',
        title:'',
        input:'',
        searchlistzb:'',
        searchlistwz:'',
        searchliststatus:false,
        searchliststatusnone:false,
      }
  },
  mounted(){
      this.getReport()
  },
  methods:{
       searchcheck(item,index){
      this.$store.commit('getindicatordata',item)
      this.$router.push({ path:'/dataQuery',query:{type:2}});
    },
     inputlist(){
           if(this.input==''){
                this.searchliststatus=false
            }
            else{
                this.searchliststatus=true
                searchdata({resourceName:this.input,resourceType:'1'})
                .then(res=>{
                    
                    this.searchlistzb=res.data.data
                })
                searchdata({resourceName:this.input,resourceType:'2'})
                .then(res=>{
                
                    this.searchlistwz=res.data.data
                })
            }
        },
        wzlistcheck(item){
           this.$router.push({ path:'/article',query:{id:item.resoruceId,}}); 
        },
        getReport(){
          getReport({
              id:this.$route.query.id
          })
            .then(res=>{
                this.report_id = res.data.id
                this.report_name = res.data.template_name
                this.$nextTick(()=>{
                    this.$refs.design.initData(res.data)
                })
            })
      },
      
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/public.scss';
        .article-content{
            min-height: calc(100vh - 50px);
                padding: 0 10px 10px;
                background-color: #fff;
                display: inline-block;
            
        }
        .article-title{
                text-align: center;
                font-size: 30px;
                height: 70px;
                line-height: 70px;
                float: left;
                width: 100%;
            }
        .article-foot{
          width: 100%;
          height: 140px;
          background: linear-gradient(360deg,rgba(37,122,214,1) 0%,rgba(93,175,244,1) 100%);
          margin-top: 50px;
          span:nth-child(1){
              margin-top: 35px;
          }
          span{
            height: 35px;
            width: 100%;
            text-align: center;
            line-height: 35px;
            font-size: 14px;
            float: left;
            color: #fff;
          }
        }
</style>


// WEBPACK FOOTER //
// src/pages/reportdetail/reportdetail.vue